import { getDaysSinceDateString } from '../helper/get-days-since-date-string';
import { getReviewSubmissionClientData } from '../helper/get-review-submission-client-data';
import { emitSubmitServerActionTracking } from '../tracking/submit-action';
import { getReviewFormData } from './submission/get-review-form-data';

export interface TrackSuccessParams {
    rootElement: Pick<HTMLElement, 'querySelector' | 'querySelectorAll' | 'dataset'>;
    success: boolean;
    furtherReviewReminders?: number;
}

export const trackServerAction = async ({ rootElement, success, furtherReviewReminders }: TrackSuccessParams) => {
    const clientData = getReviewSubmissionClientData({ rootElement });
    if (clientData.status !== 'CAN_SUBMIT') throw new Error('Review submission data is not submittable');

    const reviewFormData = await getReviewFormData({ rootElement });
    if (reviewFormData.stars === undefined) throw new Error('No rating selected');

    let daysSinceOrder: number | undefined;
    if (clientData.variation.orderDate !== null) daysSinceOrder = getDaysSinceDateString({ dateString: clientData.variation.orderDate });

    emitSubmitServerActionTracking({
        assemblyValue: reviewFormData.assembly,
        comfortValue: reviewFormData.comfort,
        daysSinceOrder,
        productDesignValue: reviewFormData.designAppearance,
        variationId: clientData.variation.id,
        source: clientData.reviewSource,
        productFitValue: reviewFormData.fit,
        productQualityValue: reviewFormData.quality,
        recommendation: reviewFormData.recommended,
        stars: reviewFormData.stars,
        textLength: reviewFormData.text?.length ?? 0,
        valueForMoneyValue: reviewFormData.pricePerformanceRatio,
        imagesCount: reviewFormData.images?.length ?? 0,
        success,
        furtherReviewReminders,
    });
};
